module.exports = __webpack_public_path__ + "img/39.7e1d8a4c.jpg";